/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CdvxStats } from './cdvxStats';
import { CdvxRuntime } from './cdvxRuntime';


/**
 * Information for a DVX
 */
export interface CdvxInfo { 
    cloud_dvx_az_id?: string;
    cloud_dvx_region?: string;
    cloud_dvx_type?: string;
    creation_timestamp_ms?: number;
    /**
     * CDvx UUID
     */
    id: string;
    /**
     * Is CDVX
     */
    is_cloud_dvx?: boolean;
    is_live?: boolean;
    /**
     * Is VMC
     */
    is_vmc_eligible?: boolean;
    /**
     * name
     */
    name: string;
    runtime?: CdvxRuntime;
    stats: CdvxStats;
    /**
     * name
     */
    version?: string;
}

